exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination-buttons {\n    display:inline-block;\n    font-size: 12px;\n    margin-top: 0px;\n}\n.fw-400 {\n    font-weight: 400 !important;\n}\n", ""]);

// exports
